import { RouterProvider } from "react-router-dom";
import { router } from "utilities";
import { AuthenticationProvider } from "contexts";
import { ThemeContextProvider } from "hooks";
import { IntlProvider } from "react-intl";

export default function App() {
 return (
   <AuthenticationProvider>
    <ThemeContextProvider>
     <IntlProvider locale="en-ZA">
      <RouterProvider router={router} />
     </IntlProvider>
    </ThemeContextProvider>
   </AuthenticationProvider>
 );
}
